

















import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { Ref } from '@vue/composition-api'
import { formFieldProps } from '~/constants/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  components: { FieldError },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const value = ref<string[]>([])

    function onValue(v: Ref<string[]>) {
      value.value = v.value || []
    }

    const { error, valueChanged } = useClassifiedForm(props, { onValue })

    const options = computed(() => specs.value?.values || [])

    const handleExtrasChange = (v: string[]) => {
      valueChanged(name.value, v)
    }

    return { value, error, options, handleExtrasChange }
  }
})
